import createAPI from '../axios'

// 实践周管理相关API
const teachingWeekManage = {
	teachingPlan: {
	    list: config => createAPI('/teachingPlan/list', 'post', config),
        initOption: config => createAPI('/teachingPlan/initOption', 'post', config),
        queryTeacher: config => createAPI('/teachingPlan/queryTeacher', 'post', config),
        querySite: config => createAPI('/teachingPlan/querySite', 'post', config),
        saveTeachingWeek: config => createAPI('/teachingPlan/saveTeachingWeek', 'post', config),
        delTeachingWeek: config => createAPI('/teachingPlan/delTeachingWeek', 'post', config),
	},
    classArrangement: {
        list: config => createAPI('/classArrangement/list', 'post', config),
        initOption: config => createAPI('/classArrangement/initOption', 'post', config),
        queryTree: config => createAPI('/classArrangement/queryTree', 'post', config),
        initBlankKCB: config => createAPI('/classArrangement/initBlankKCB', 'post', config),
        courseOption: config => createAPI('/classArrangement/courseOption', 'post', config),
        savePracticeArrange: config => createAPI('/classArrangement/savePracticeArrange', 'post', config),
        delArrangement: config => createAPI('/classArrangement/delArrangement', 'post', config),
    },
};

export default teachingWeekManage;



// WEBPACK FOOTER //
// ./src/api/modules/teachingWeekManage.js